import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { MenuProvider } from "./Context/Menucontext";
import { AuthProvider } from "./Context/AuthContext";
import { ToastProvider } from "./Context/ToastContext";
import { CustomerFormProvider } from "./Context/CustomerFormContext";
import { VesselOwnerFormProvider } from "./vesselOwner/Libs/useVesselOwnerFrom";
import "./global.css"

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
        <AuthProvider>
          <CustomerFormProvider>
            <VesselOwnerFormProvider>
              <MenuProvider>
                <App />
              </MenuProvider>
            </VesselOwnerFormProvider>
          </CustomerFormProvider>
        </AuthProvider>
        </ToastProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
